<template>
  <transition name="router-slid">
    <div
      class="creative-cell"
      @mouseenter="showLayer(index)"
      @mouseleave="hideLayer"
      :style="{ maxHeight: maxHeight + 'px' }"
      :class="{ 'selected-card': creative.checked, hovered: hover_index === index }"
    >
      <div class="header">
        <el-row justify="space-between">
          <el-col :span="12">
            <i class="icon-y-date mr-1"></i>
            {{ creative.ct.substring(0, 10) }}
          </el-col>
          <el-col :span="12" class="right" v-if="false">
            <el-checkbox
              label="Select"
              v-model="creative.checked"
              @change="$emit('changeCreative', creative, show_detail)"
            ></el-checkbox>
          </el-col>
        </el-row>
      </div>
      <div class="body">
        <div class="mb-2">
          <h3 v-if="creative.name.length <= 31">{{ creative.name }}</h3>
          <el-popover
            v-else
            popper-class="transparent-popper line-popper"
            placement="bottom"
            trigger="hover"
            :content="creative.name"
          >
            <h3 slot="reference">{{ creative.name }}</h3>
          </el-popover>
          <div v-if="creative.ad_type !== 3">
            <p v-if="creative.description.length <= 148">{{ creative.description }}</p>
            <el-popover
              v-else
              popper-class="transparent-popper line-popper"
              placement="bottom"
              trigger="hover"
              :content="creative.description"
            >
              <p slot="reference">{{ creative.description.substr(0, 148) + '...' }}</p>
            </el-popover>
          </div>
          <div v-else>
            <el-row>
              <el-col :span="16">
                <p class="black">{{ creative.title }}</p>
                <p>{{ creative.description }}</p>
              </el-col>
              <el-col
                :span="8"
                class="right"
                @click.native="$emit('openPreview', creative, 'push')"
              >
                <div
                  class="push-box pointer"
                  @mouseenter="showPushLayer(index)"
                  @mouseleave="hidePushLayer"
                >
                  <div v-show="hover_push_index === index" class="layer"></div>
                  <i v-show="hover_push_index === index" class="icon-y-ym_view"></i>
                  <img class="push-img" :src="creative.push_img_url || creative.img_url" />
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div
          class="creative-img pointer"
          style="height: 144px"
          @mouseenter="showImgLayer(index)"
          @mouseleave="hideImgLayer"
          @click="$emit('openPreview', creative, 'non-push')"
        >
          <div v-show="hover_img_index === index" class="layer"></div>
          <i v-show="hover_img_index === index" class="icon-y-ym_view"></i>
          <img v-lazy="creative.img_url" />
        </div>
        <div class="mt-3">
          <el-row justify="space-between">
            <el-col :span="12">
              <div class="tag">
                <el-tag :type="showType(creative.ad_type)">
                  {{ showLabel(creative.ad_type, ad_type_list) }}
                </el-tag>
              </div>
            </el-col>
            <el-col :span="12" class="right">
              <i
                class="icon-y-ym_star_full"
                v-for="(i, index) in creative.value"
                :key="index + '-' + i"
              ></i>
              <i
                class="icon-y-ym_star"
                v-for="(i, index) in 5 - creative.value"
                :key="index + '--' + i"
              ></i>
            </el-col>
          </el-row>
        </div>
        <hr class="line mt-3" />
        <el-row justify="space-between" class="item-footer">
          <el-col :span="16">
            <el-tag type="info mr-2 mb-1">
              {{ showLabel(creative.category, creative_category) }}
            </el-tag>
            <el-tag type="info" v-if="creative.offer_type === 2">
              {{ showLabel(creative.stream_type, offer_setting.restriction_type) }}
            </el-tag>
          </el-col>
          <el-col :span="8" class="right">
            <div v-if="creative.country.split('|').length < 3">
              <template v-for="(item, index) in creative.country.split('|')">
                <img
                  v-if="item.toLowerCase() !== 'global'"
                  :key="index"
                  class="flag-md"
                  :src="`https://assets.ymcdn.net/app/images/flag/${item.toLowerCase()}.png`"
                />
                <i v-else class="icon-y-earth" :key="index"></i>
              </template>
            </div>
            <div v-else>
              <el-popover
                popper-class="transparent-popper line-popper"
                placement="bottom"
                trigger="hover"
              >
                <template v-for="(item, index) in creative.country.split('|')">
                  <img
                    v-if="item.toLowerCase() !== 'global'"
                    :key="index"
                    class="flag-md pointer"
                    :src="`https://assets.ymcdn.net/app/images/flag/${item.toLowerCase()}.png`"
                  />
                  {{ item.toUpperCase() }}
                </template>
                <div slot="reference">
                  <img
                    class="flag-md"
                    :src="
                      `https://assets.ymcdn.net/app/images/flag/${creative.country
                        .split('|')[0]
                        .toLowerCase()}.png`
                    "
                  />
                  ...
                </div>
              </el-popover>
            </div>
          </el-col>
        </el-row>
        <transition name="fade" mode="out-in">
          <el-row
            justify="space-between"
            class="mt-3"
            v-show="show_detail || hover_index === index"
          >
            <el-col :span="12">
              <el-button
                type="primary"
                v-clipboard:copy="creative.img_url"
                v-clipboard:success="onCopy"
                class=""
              >
                Copy Image
              </el-button>
            </el-col>
            <el-col :span="12" class="right">
              <el-button
                type="primary"
                @click="openFile(creative.file_url)"
                class=""
                :disabled="!creative.file_url"
              >
                Download LP
              </el-button>
            </el-col>
          </el-row>
        </transition>
        <el-button
          class="mt-3 full-button"
          type="success"
          @click="$emit('offerRecommended')"
          v-show="show_detail || hover_index === index"
          v-if="false"
        >
          <i class="icon-y-pic mr-2"></i>
          Offer Recommended
        </el-button>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      hover_index: '',
      hover_push_index: '',
      hover_img_index: '',
      maxHeight: 999,
    }
  },
  computed: {
    ...mapState(['offer_setting']),
  },
  created() {
    this.$store.dispatch('getOfferSetting')
  },
  props: {
    creative: {
      type: Object,
      default() {
        return {
          checked: false,
        }
      },
    },
    index: {
      type: Number,
      default() {
        return 0
      },
    },
    ad_type_list: {
      type: Array,
      default() {
        return []
      },
    },
    creative_category: {
      type: Array,
      default() {
        return []
      },
    },
    show_detail: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  methods: {
    clear() {
      this.creative.checked = false
    },
    showType(type) {
      let map = {
        1: '',
        2: 'info',
        3: 'warning',
        4: 'danger',
        5: 'success',
      }
      return map[type]
    },
    showLayer(index) {
      this.hover_index = index
      this.maxHeight = 9999
    },
    hideLayer() {
      this.hover_index = ''
      this.maxHeight = 999
    },
    showImgLayer(index) {
      this.hover_img_index = index
    },
    hideImgLayer() {
      this.hover_img_index = ''
    },
    showPushLayer(index) {
      this.hover_push_index = index
    },
    hidePushLayer() {
      this.hover_push_index = ''
    },
    openFile(url) {
      window.open(url, '_blank')
    },
  },
}
</script>

<style lang="scss">
.router-slid-enter-active,
.router-slid-leave-active {
  transition: all 0.4s;
}
.router-slid-enter,
.router-slid-leave-active {
  transform: translate3d(0, 3rem, 0);
  opacity: 0;
}
.flag-md {
  margin-left: 8px;
  width: 24px;
  height: 16px;
}
.creative-cell {
  max-width: 288px;
  width: 288px;
  border: 1px solid #ebebeb;
  box-shadow: 0px 4px 8px 0px rgba(33, 35, 41, 0.08);
  border-radius: 4px;
  transition: 2s;
  .push-box {
    width: 48px;
    position: relative;
    height: 48px;
    float: right;
    .layer {
      width: 48px;
      height: 48px;
    }
    .icon-y-ym_view {
      top: 50%;
      left: 50%;
      margin-left: -8px;
      margin-top: -8px;
    }
  }
  &.hovered {
    box-shadow: 0px 10px 20px 0px rgba(33, 35, 41, 0.12);
  }
  img {
    // border-radius: 12px;
    width: 100%;
    // display: block;
    background-size: contain;
  }
  .push-img {
    width: 48px;
    height: 48px;
  }
  .flag-md {
    margin-left: 8px;
    width: 24px;
    height: 16px;
  }
  .icon-y-earth {
    background-image: linear-gradient(151deg, rgba(249, 0, 120, 1) 0%, rgba(0, 128, 204, 1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .item-footer {
    margin-top: 1rem;
    position: relative;
    display: flex;
    align-items: center;
  }
  .header {
    padding: 10px 16px;
    height: 40px;
    background: #fafcff;
    box-sizing: border-box;
    border-bottom: 1px solid #ebeef5;
    font-size: 12px;
    color: #9b9ea3;
    line-height: 20px;
    i {
      color: #d0d3d9;
    }
    .el-radio {
      color: #9b9ea3;
      .el-radio__label {
        font-size: 12px;
      }
    }
  }
  &.selected-card .header {
    background: #0080cc;
    border-bottom: 1px solid #0080cc;
    color: #fff;
    i {
      color: #fff;
    }
    .el-checkbox__inner {
      border-color: #fff;
    }
    .el-checkbox__label {
      color: #fff;
    }
    .el-radio {
      color: #fff;
      .el-radio__label {
        color: #fff;
      }
      .el-radio__input.is-checked .el-radio__inner {
        border-color: #fff;
        background: #fff;
        &::after {
          background: #0080cc;
        }
      }
    }
  }
  .body {
    padding: 0 16px 16px 16px;
    transition: 2s;
    .black {
      color: #37383a;
    }
    h3 {
      margin: 10px 0;
      font-size: 16px;
      color: #37383a;
      line-height: 24px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    p {
      color: #9b9ea3;
      font-size: 14px;
      line-height: 22px;
    }
    .line {
      border: 1px solid #f0f3fa;
      border-bottom: none;
    }
  }
}
</style>
